module.exports = __webpack_public_path__ + "static/parade-2019-house08-6a49a1c43a461fcdae015c398a480652.jpg";